import React from 'react';
import TeamContent from '../components/team/TeamContent';

const TeamPage: React.FC = () => {
  return <TeamContent />;
};

export default TeamPage;
